<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>computer</md-icon>
                    </div>
                    <h4 class="title">系统模型列表</h4>
                </md-card-header>
                <md-card-content>
                    <v-data-table :headers="headers" :items="queriedData" :items-per-page="5" :sort-desc="[false, true]" hide-default-footer class="paginated-table table-striped table-hover">
                        <template v-slot:top>
                            <v-row justify="space-between">
                                <v-col class="d-flex" cols="6" sm="2">
                                    <v-select v-model="pagination.perPage" :items="pagination.perPageOptions" label="每页显示"></v-select>
                                </v-col>
                                <v-col class="d-flex" cols="6" sm="2">
                                    <v-text-field v-model="searchQuery" label="查找" type="queryParams.name" class="mb-3" clearable style="width: 200px"></v-text-field>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.option="{ item }">
                            <md-button class="md-just-icon md-success md-round md-simple" @click.native="handleEdit(item)" style="padding-right: 30px;">
                                <md-icon>edit</md-icon>
                            </md-button>
                            <!-- <md-button class="md-just-icon md-danger md-round md-simple" @click.native="handleDelete(item)">
            <md-icon>close</md-icon>
        </md-button> -->
                        </template>
                    </v-data-table>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            {{ from + 1 }} 到 {{ to }} ，共 {{ total }}
                        </p>
                    </div>
                    <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="pagination.total">
                    </pagination>
                </md-card-actions>
            </md-card>
        </div>
    </div>
</template>
<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
    components: {
        Pagination,
    },
    computed: {
        /***
         * Returns a page from the searched data or the whole data. Search is performed in the watch section below
         */
        queriedData() {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData;
            }
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0 ?
                this.searchedData.length :
                this.tableData.length;
        },
    },
    data() {
        return {
            headers: [
                { text: '课程', align: 'center', value: 'course' },
                { text: '项目', align: 'center', value: 'project' },
                { text: '系统元件', align: 'center', value: 'name' },
                { text: '公开', align: 'center', value: 'public' },
                { text: '类型', align: 'center', value: 'type' },
                { text: '编辑', align: 'center', value: 'option', width: "100px" }
            ],
            currentSort: "name",
            currentSortOrder: "asc",
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0,
            },
            searchQuery: "",
            propsToSearch: ["name"],
            tableData: [{
                    id: "1000",
                    course: "变电站运行与检修",
                    project: "变电站运行",
                    name: "值班员",
                    public: "否",
                    type: "UI",
                    desc: "",
                    update: "2022-06-02",
                },
                {
                    id: "1001",
                    course: "变电站运行与检修",
                    project: "变电站运行",
                    name: "巡视人",
                    public: "否",
                    type: "摄像机",
                    desc: "",
                    update: "2022-06-02",
                },
                {
                    id: "1002",
                    course: "变电站运行与检修",
                    project: "变电站运行",
                    name: "监护人",
                    public: "否",
                    type: "录屏",
                    desc: "",
                    update: "2022-06-02",
                },
            ],
            searchedData: [],
            fuseSearch: null,
        };
    },
    methods: {
        toNewRole() {
            this.$router.push({ path: "./newsystemmod" });
        },
        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort;
                if (this.currentSortOrder === "desc") {
                    return a[sortBy].localeCompare(b[sortBy]);
                }
                return b[sortBy].localeCompare(a[sortBy]);
            });
        },
        handleEdit(item) {
            this.$router.push({ path: "./newsystemmod" });
        },
        handleDelete(item) {
            Swal.fire({
                title: "删除信息",
                text: `${item.name} 记录被删除后将无法恢复，请确认！`,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success btn-fill",
                cancelButtonClass: "md-button md-danger btn-fill",
                confirmButtonText: "确 定",
                cancelButtonText: "取 消",
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.deleteRow(item);
                    Swal.fire({
                        title: "已删除!",
                        text: `您已经删除 ${item.name}`,
                        type: "success",
                        confirmButtonClass: "md-button md-success btn-fill",
                        buttonsStyling: false,
                    });
                }
            });
        },
        deleteRow(item) {
            let indexToDelete = this.tableData.findIndex(
                (tableRow) => tableRow.id === item.id
            );
            if (indexToDelete >= 0) {
                this.tableData.splice(indexToDelete, 1);
            }
        },
    },
    mounted() {
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
            keys: ["name", "email"],
            threshold: 0.3,
        });
    },
    watch: {
        /**
         * Searches through the table data by a given query.
         * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
         * @param value of the query
         */
        searchQuery(value) {
            let result = this.tableData;
            if (value !== "") {
                result = this.fuseSearch.search(this.searchQuery);
            }
            this.searchedData = result;
        },
    },
};
</script>
<style lang="css" scoped>
.md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
}
</style>